import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { alpha } from '@mui/material/styles';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

const REPORT_ICON = 'solar:chart-2-bold';
const GLOBAL_ICON = 'solar:global-bold';

export function ConversationTypeIcon({ conversationType, size = 32, iconWidth = 18, sx = {} }) {
  const isReportConversation = conversationType === 'report';

  return (
    <Tooltip title={isReportConversation ? 'Report Insights' : 'Global Insights'} placement="top" arrow>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          width: size,
          height: size,
          borderRadius: 1,
          bgcolor: (theme) => alpha(theme.palette[isReportConversation ? 'success' : 'info'].main, 0.16),
          color: `${isReportConversation ? 'success' : 'info'}.dark`,
          ...sx,
        }}
      >
        <Iconify icon={isReportConversation ? REPORT_ICON : GLOBAL_ICON} width={iconWidth} />
      </Box>
    </Tooltip>
  );
}
